import { render, staticRenderFns } from "./SfLink.vue?vue&type=template&id=2e13fdd7"
import script from "./SfLink.vue?vue&type=script&lang=js"
export * from "./SfLink.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfLink.vue?vue&type=style&index=0&id=2e13fdd7&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "921a5a32"
  
)

export default component.exports